import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';

const CvSummaryView = (props) => {
  console.log('props', props);
  // if (localStorage.getItem("token") != null) {
  return (
    <>
      <div className="registration-form_main">
        <div
          className="registration-form_wrapper"
          style={{ padding: '78px 73px' }}
        >
          <div className="dashboard-body-area" style={{ width: '100%' }}>
            <section className="dashboard-page-title">
              <h2>
                The following details have been temporarily saved to the
                system,but Your application is not been submmited yet.Please
                take a moment to review the details below then follow the
                instructions at the bottom of the page.
              </h2>
            </section>
            <section className="dashboard-page-title">
              <h2>
                <strong>Step 1: Personal Details Summary </strong>
              </h2>
            </section>
            <div style={{ marginTop: '30px' }}>
              <Table responsive>
                <tbody>
                  <tr>
                    <td style={{ minWidth: '15em' }}>First Name</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.first_name}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Last Name</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.last_name}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Email Address</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.email}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Job Title</td>
                    <td>
                      <span className="title-crop">{props.title_type}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Date of Birth</td>
                    <td>
                      <span className="title-crop">{props.formated_date}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Post Code</td>
                    <td>
                      <span className="title-crop">
                        {props.perssonal_detail.zipcode}
                      </span>
                    </td>
                  </tr>
                  {props.perssonal_detail.address_line_1 &&
                    props.perssonal_detail.address_line_1 != null && (
                      <tr>
                        <td style={{ minWidth: '15em' }}>Address Line 1</td>
                        <td>
                          <span>{props.perssonal_detail.address_line_1}</span>
                        </td>
                      </tr>
                    )}
                  {props.perssonal_detail.address_line_2 &&
                    props.perssonal_detail.address_line_2 != null && (
                      <tr>
                        <td style={{ minWidth: '15em' }}>Address Line 2</td>
                        <td>
                          <span>{props.perssonal_detail.address_line_2}</span>
                        </td>
                      </tr>
                    )}

                  {props.perssonal_detail.address_line_3 &&
                    props.perssonal_detail.address_line_3 != null && (
                      <tr>
                        <td style={{ minWidth: '15em' }}>Address Line 3</td>
                        <td>
                          <span>{props.perssonal_detail.address_line_3}</span>
                        </td>
                      </tr>
                    )}
                  <tr>
                    <td style={{ minWidth: '15em' }}>County</td>
                    <td>
                      <span>{props.perssonal_detail.city}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Country</td>
                    <td>
                      <span>{props.perssonal_detail.country}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ minWidth: '15em' }}>
                      Do you have a right to work in the UK
                    </td>
                    <td>
                      <span>{props.right_to_work_selected}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Cv Uploaded</td>
                    <td>
                      <span>{props.file_name}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ minWidth: '15em' }}>Image Uploaded</td>
                    <td>
                      <span>{props.profile_picture}</span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <section
              className="dashboard-page-title"
              style={{ marginTop: '10px' }}
            >
              <h2>
                If any of the details are incorrect please hit the edit button{' '}
              </h2>
              <div
                style={{ padding: '11px 0', width: '350px', margin: '0px 0px' }}
              >
                <form>
                  <div
                    className="form-btn_group"
                    style={{ textAlign: 'start' }}
                  >
                    <a href="/registration/submit-cv/#edit">
                      <button
                        type="button"
                        onClick={(e) => {
                          localStorage['from-summary'] = true;
                        }}
                        style={{ width: '285px' }}
                        className="btn btn-border"
                      >
                        Edit <i className="fa fa-pencil-square-o"></i>
                      </button>
                    </a>
                  </div>
                </form>
              </div>
            </section>
            <section
              className="dashboard-page-title"
              style={{ marginTop: '10px' }}
            >
              <h2>If These are correct please hit the submit button</h2>
              <div
                className="login-form"
                style={{ padding: '11px 0', width: '286px', margin: '0px 0px' }}
              >
                <form>
                  <div className="field-box">
                    <a href="/registration/cv-complete">
                      <button type="button">
                        Submit<i className="fa fa-sign-in"></i>
                      </button>
                    </a>
                  </div>
                </form>
              </div>
            </section>
            {localStorage.getItem('is_admin') &&
            localStorage.getItem('from_applicant') ? (
              <section>
                <hr />
                <h2 style={{ marginBottom: '10px' }}>Admin Section</h2>
                <div className="form-group">
                  <div className="form-row">
                    <div className="col">
                      <label style={{ fontSize: 'small' }}>
                        <input
                          onChange={(e) => props.handelData(e)}
                          style={{ marginRight: '10px' }}
                          name="check"
                          type="radio"
                          value="Decline Application"
                        />
                        Decline Application
                      </label>
                    </div>
                    <div className="col">
                      <label style={{ fontSize: 'small' }}>
                        <input
                          onChange={(e) => props.handelData(e)}
                          style={{ marginRight: '10px' }}
                          name="check"
                          type="radio"
                          value="Schedule Interview"
                        />
                        Schedule Interview
                      </label>
                    </div>
                    <div className="col">
                      <label style={{ fontSize: 'small' }}>
                        <input
                          onChange={(e) => props.handelData(e)}
                          style={{ marginRight: '10px' }}
                          name="check"
                          type="radio"
                          value="Request More Information"
                        />
                        Request More Information
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-row">
                    <div className="col">
                      <textarea
                        value={props.user_verification_description}
                        onChange={(e) => props.handeltext(e.target.value)}
                        name="message"
                        rows="10"
                        cols="30"
                        style={{ width: '100%' }}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="login-form">
                  <div className="field-box">
                    <button type="button" onClick={props.handelsubmit}>
                      Send Notice<i className="fa fa-sign-in"></i>
                    </button>
                  </div>
                </div>
              </section>
            ) : null}
          </div>
        </div>
      </div>
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
      />
    </>
  );

  // }else{
  //             return(
  //                 <Navigate to="/login" />
  //              )
  // }
};

export default CvSummaryView;
